import React, { useContext, useEffect, useState } from "react";
import { ChevronRight, HelpCircle, Mail, MessageCircle, X } from "react-feather";
import { useScreenTransition } from "../Hooks/useScreenTransition";
import { DataContext } from "../Context/DataContext";
import { SUPPORT_EMAIL, SUPPORT_PHONE, WHATSAPP_URL } from "../utility/support";
import WhatsAppIcon from "./WhatsAppIcon";
import "./AccountUi.css";

// "Help" in the account menu and the avatar menu: where a client who is stuck
// can go. One panel for the whole app (HelpPanelHost, mounted once inside the
// router in App.js); anything opens it with openHelp().
const OPEN_EVENT = "everbary:open-help";

export { SUPPORT_EMAIL, SUPPORT_PHONE };

export const openHelp = () => {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
};

const HelpPanel = ({ onClose }) => {
  const { transitionTo } = useScreenTransition();
  const { userData } = useContext(DataContext);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const go = (path) => (e) => {
    e.preventDefault();
    onClose();
    transitionTo(path, e);
  };

  return (
    <div className="newPopUpModalWrap" onClick={onClose}>
      <div className="newPopUpModalContainer helpPanel" role="dialog" aria-modal="true" aria-labelledby="helpPanelTitle"
        onClick={(e) => e.stopPropagation()}>
        <h2 className="newPopUpModalTitle" id="helpPanelTitle">Help</h2>
        <button type="button" className="helpPanelClose" aria-label="Close" onClick={onClose}><X size={20} /></button>

        <div className="helpList">
          {userData && (
            <div className="helpPanelOrder">
              <MessageCircle className="helpPanelIcon" />
              <span className="helpPanelBody">
                <span className="helpPanelStrong">Is it about an order?</span>
                <span className="helpPanelText">Write in the order's chat: it reaches the team working on it.</span>
              </span>
              <a href="/account/orders" className="helpPanelLink" onClick={go("/account/orders")}>Go to Orders</a>
            </div>
          )}

          <a href="/faq" className="helpPanelRow" onClick={go("/faq")}>
            <HelpCircle className="helpPanelIcon" />
            <span className="helpPanelBody">
              <span className="helpPanelStrong">Frequently asked questions</span>
              <span className="helpPanelText">Prices, turnaround, certification, USCIS</span>
            </span>
            <ChevronRight className="helpPanelChevron" />
          </a>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="helpPanelRow">
            <Mail className="helpPanelIcon" />
            <span className="helpPanelBody">
              <span className="helpPanelStrong">{SUPPORT_EMAIL}</span>
              <span className="helpPanelText">Email support</span>
            </span>
            <ChevronRight className="helpPanelChevron" />
          </a>
          {/* WhatsApp only: nobody answers calls on this number. */}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="helpPanelRow" data-testid="help-whatsapp">
            <WhatsAppIcon className="helpPanelIcon" />
            <span className="helpPanelBody">
              <span className="helpPanelStrong">{SUPPORT_PHONE}</span>
              <span className="helpPanelText">WhatsApp messages only</span>
            </span>
            <ChevronRight className="helpPanelChevron" />
          </a>
        </div>
      </div>
    </div>
  );
};

export const HelpPanelHost = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, show);
    return () => window.removeEventListener(OPEN_EVENT, show);
  }, []);

  return open ? <HelpPanel onClose={() => setOpen(false)} /> : null;
};

export default HelpPanel;
